import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { startSessionTimer, clearSessionTimer } from './sessionTimeout';
import apiClient from '../../api/apiClient';
import tenantStorage from '../../utils/tenantStorage';

const ACTIVITY_EVENTS = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];

const isPgRole = () => tenantStorage.getItem('userRole') === 'RT_PG';
const hasSession = () => Boolean(tenantStorage.getItem('accessToken'));

const SessionTimeoutHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      try {
        await apiClient.post('/logout');
      } catch (e) {}
      tenantStorage.clear();
      clearSessionTimer();
      navigate('/login', { state: { mode: 'SESSION_INACTIVE' } });
    };

    const syncTimer = () => {
      clearSessionTimer();
      if (!hasSession() || isPgRole()) {
        return;
      }
      startSessionTimer(logout);
    };

    const resetAndRestart = () => {
      if (!hasSession() || isPgRole()) {
        clearSessionTimer();
        return;
      }
      clearSessionTimer();
      startSessionTimer(logout);
    };

    syncTimer();
    window.addEventListener('renttick-auth-updated', syncTimer);
    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, resetAndRestart, true);
    });

    return () => {
      clearSessionTimer();
      window.removeEventListener('renttick-auth-updated', syncTimer);
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, resetAndRestart, true);
      });
    };
  }, [navigate]);

  return null;
};

export default SessionTimeoutHandler;
